import { Component,OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { navItems } from '../../_nav';

import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent implements OnInit {
  public sidebarMinimized = false;
  public navItems = navItems;
  userDetails: any;
  userName: any;

  constructor(private router: Router, private modalService:NgbModal) { }
  ngOnInit(): void {
    this.userDetails = JSON.parse(localStorage.getItem("LoginData"))
    console.log('userDetails',this.userDetails)
    this.userName = this.userDetails.name;
    //  this.userName = JSON.parse(this.api.getToken()).individualName;
   //  console.log(this.userDetails.token,'this.TOKEN HERE USER MENU');
    
 }
  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }
  logout(): any {
    localStorage.clear();
    this.modalService.dismissAll()
    this.router.navigateByUrl('/login');
  }
  back(){
    window.history.back();
  }
  logoutModal(modal:any){
    this.modalService.open(modal)
  }
}
